/**
 * The activation-key restriction is decided server-side (Liquid) and stamped
 * on #checkout-form as data-activation-key-blocked. It must never be cleared
 * by client-side interactions like checking the legal agreement checkbox -
 * only a fresh section render (cart changed) can lift it.
 */
function isActivationKeyBlocked() {
  const checkoutForm = document.querySelector('#checkout-form');
  return checkoutForm?.dataset.activationKeyBlocked === 'true';
}

function toggleButton() {
  const checkbox = document.querySelector('#agree-sidecart');
  const checkoutButton = document.querySelector('.btn-checkout-js');
  const errorMessage = document.querySelector('.js-threshold_message');

  if (checkbox.checked && !isActivationKeyBlocked()) {
    checkoutButton.classList.remove('button-disabled');
    errorMessage.style.display = 'none';
  } else {
    checkoutButton.classList.add('button-disabled');
  }
}

/**
 * Open and close side cart with various buttons
 */
export const checkValidation = () => {
  const checkbox = document.querySelector('#agree-sidecart');
  const checkoutForm = document.querySelector('#checkout-form');

  toggleButton();

  checkbox.addEventListener('change', () => toggleButton());

  checkoutForm.addEventListener('submit', function (event) {
    const checkoutButton = document.querySelector('.btn-checkout-js');
    const errorMessage = document.querySelector('.js-threshold_message');
    const activationKeyMessage = document.querySelector('.js-activation-key_message');

    if (isActivationKeyBlocked()) {
      event.preventDefault();
      activationKeyMessage?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    if (checkoutButton.classList.contains('button-disabled')) {
      event.preventDefault();
      errorMessage.style.display = 'flex';
    }
  });
};

/**
 * Same activation-key guard as checkValidation(), for the /cart page's own
 * checkout form (#js-cart-form / #checkout), which has no legal-checkbox
 * gate but must equally refuse to submit while data-checkout-blocked="true".
 */
export const checkCartPageValidation = () => {
  const cartForm = document.querySelector('#js-cart-form');

  if (!cartForm) return;

  cartForm.addEventListener('submit', function (event) {
    if (cartForm.dataset.checkoutBlocked === 'true') {
      event.preventDefault();
      document
        .querySelector('.js-activation-key_message')
        ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });
};
